import { useEffect, useState } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export function getWebActiveState(doc = document) {
  if (!doc) return true;
  if (doc.visibilityState === "hidden" || doc.hidden === true) return false;
  return typeof doc.hasFocus !== "function" || doc.hasFocus();
}

export default function useAppActiveState() {
  const [isActive, setIsActive] = useState(() => getWebActiveState());

  useEffect(() => {
    let disposed = false;
    let nativeHandle = null;
    const updateWebState = () => {
      if (!disposed && !Capacitor.isNativePlatform()) setIsActive(getWebActiveState());
    };

    const handleFocus = () => {
      if (!disposed && !Capacitor.isNativePlatform() && document.visibilityState !== "hidden") setIsActive(true);
    };
    const handleBlur = () => {
      if (!disposed && !Capacitor.isNativePlatform()) setIsActive(false);
    };

    document.addEventListener("visibilitychange", updateWebState);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    if (Capacitor.isNativePlatform()) {
      App.getState()
        .then(({ isActive: nativeIsActive }) => { if (!disposed) setIsActive(nativeIsActive); })
        .catch(() => { if (!disposed) setIsActive(document.visibilityState !== "hidden"); });
      App.addListener("appStateChange", ({ isActive: nativeIsActive }) => {
        if (!disposed) setIsActive(nativeIsActive);
      }).then((handle) => {
        if (disposed) handle.remove();
        else nativeHandle = handle;
      });
    }

    return () => {
      disposed = true;
      nativeHandle?.remove();
      document.removeEventListener("visibilitychange", updateWebState);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  return isActive;
}
